import React from 'react';
import { ReactComponent as Border } from './bt-border-guedelon.svg';
import clsx from 'clsx';
import style from './button.module.scss';

type GuedelonButtonLinkProps = {
    external?: boolean;
    disabled?: boolean;
} & React.HTMLProps<HTMLAnchorElement>;

export const GuedelonButton: React.FC<GuedelonButtonLinkProps> = ({
    href,
    children,
    external = false,
    disabled = false,
    rel = '',
    ...props
}: GuedelonButtonLinkProps) => {
    if (external && rel === '') {
        rel = 'noopener noreferrer';
    }
    if (disabled) {
        props.onClick = () => false;
    }
    return (
        <a {...props} className={style.a} href={href} {...(external ? { target: '_blank', rel } : {})}>
            <div className={clsx(style.sharedButton, props.className)}>
                <div className={style.text}>{children}</div>
                <div className={style.background}>
                    <Border />
                </div>
            </div>
        </a>
    );
};

export const GuedelonSubmitButton: React.FC<React.HTMLProps<HTMLButtonElement>> = ({
    children,
    ...props
}: React.HTMLProps<HTMLButtonElement>) => {
    return (
        //@ts-ignore react typing does not correspond exactly to the html typing
        <button {...props} className={style.a}>
            <div className={clsx(style.sharedButton, props.className)}>
                <div className={style.text}>{children}</div>
                <div className={style.background}>
                    <Border />
                </div>
            </div>
        </button>
    );
};
